<template>
  <img
    src="/coin-pile.png"
    alt="Coin pile"
    :width="width || 82"
    :height="height || 105"
    style="object-fit: contain"
  />
</template>

<script setup lang="ts">
interface Props {
  width?: number;
  height?: number;
}

withDefaults(defineProps<Props>(), {
  width: 82,
  height: 105,
});
</script>
